const globalStyles = `
:root {
  font-synthesis: none;
  text-rendering: optimizeLegibility;
}
* { box-sizing: border-box; }
html, body, #root { margin: 0; min-height: 100%; }
html[data-runtime="desktop"],
html[data-runtime="desktop"] body,
html[data-runtime="desktop"] #root {
  height: 100%;
  overflow: hidden;
}
body {
  background: var(--ark-canvas);
  color: var(--ark-text);
  font-family: var(--ark-font-family);
  min-width: 320px;
}
::selection {
  background: var(--ark-primary-soft-hover);
  color: var(--ark-text);
}
*::-webkit-scrollbar { height: 8px; width: 8px; }
*::-webkit-scrollbar-thumb {
  background: var(--ark-fill-secondary);
  border: 2px solid transparent;
  background-clip: padding-box;
  border-radius: 99px;
}
button, input { font: inherit; }
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto;
    transition-duration: 0.01ms !important;
  }
}
`;

// Opt-in host baseline, not a reset applied to every primitive consumer.
export function ArkGlobalStyles() {
  return <style data-ark-global-styles="">{globalStyles}</style>;
}
